var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterBridgeMRWood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 69,
    viewBox: "0 0 166 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01747 20.5746C9.01747 20.5746 72.0381 50.7149 105.832 57.5649L101.722 60.7616C101.722 60.7616 33.6777 39.7548 7.64746 22.4013L9.01747 20.5746Z",
    fill: "#C9966C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4061 5.31274C56.4061 5.31274 119.427 35.453 153.22 42.3031L149.11 45.4998C149.11 45.4998 81.0664 24.4929 55.0361 7.13943L56.4061 5.31274Z",
    fill: "#C9966C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93092 31.5348L9.01758 28.7947L9.93092 26.5114L14.4976 24.228L70.6682 5.50452V10.0712L9.93092 31.5348Z",
    fill: "#AD723D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.34082 22.858L60.1647 0.937744L70.6682 5.50445L9.93091 27.4247L0.34082 22.858Z",
    fill: "#BF8648"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.34082 22.8579V26.968L9.93091 31.5347V27.4246L0.34082 22.8579Z",
    fill: "#CB8E5A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3711 39.7551L25.4578 37.0151L26.3711 34.7317L30.9378 32.4484L87.1084 13.7249V18.2916L26.3711 39.7551Z",
    fill: "#AD723D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.781 31.0782L76.6049 9.15796L87.1083 13.7247L26.3711 35.6449L16.781 31.0782Z",
    fill: "#BF8648"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.781 31.0784V35.1884L26.3711 39.7551V35.6451L16.781 31.0784Z",
    fill: "#CB8E5A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0947 46.6047L44.1814 43.8647L45.0947 41.5813L49.6614 39.298L105.832 20.5745V25.1412L45.0947 46.6047Z",
    fill: "#AD723D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5044 37.9281L95.3283 16.0079L105.832 20.5746L45.0945 42.4949L35.5044 37.9281Z",
    fill: "#BF8648"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5044 37.928V42.038L45.0945 46.6047V42.4947L35.5044 37.928Z",
    fill: "#CB8E5A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.905 54.8248L61.9917 52.0848L62.905 49.8014L67.4718 47.5181L123.642 28.7946V33.3613L62.905 54.8248Z",
    fill: "#AD723D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3147 46.1481L113.139 24.2279L123.642 28.7946L62.9048 50.7148L53.3147 46.1481Z",
    fill: "#BF8648"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3147 46.1482V50.2582L62.9048 54.8249V50.7149L53.3147 46.1482Z",
    fill: "#CB8E5A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4556 61.675L82.5422 58.935L83.4556 56.6516L88.0223 54.3683L144.193 35.6448V40.2115L83.4556 61.675Z",
    fill: "#AD723D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.865 52.9983L133.689 31.0781L144.192 35.6448L83.4551 57.565L73.865 52.9983Z",
    fill: "#BF8648"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M73.865 52.9983V57.1083L83.4551 61.675V57.565L73.865 52.9983Z",
    fill: "#CB8E5A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.918 68.5251L104.005 65.7851L104.918 63.5017L109.485 61.2184L165.655 42.4949V47.0616L104.918 68.5251Z",
    fill: "#AD723D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3284 59.8484L155.152 37.9282L165.656 42.4949L104.918 64.4151L95.3284 59.8484Z",
    fill: "#BF8648"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3284 59.8484V63.9584L104.918 68.5251V64.4151L95.3284 59.8484Z",
    fill: "#CB8E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterBridgeMRWood);
export default __webpack_public_path__ + "static/media/winter_bridge_m_r_wood.7531e9bc62c8f50754143891b8825b78.svg";
export { ForwardRef as ReactComponent };